var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissedCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.02115V7.20215C2 7.41498 1.92817 7.59315 1.7845 7.73665C1.641 7.88032 1.46283 7.95215 1.25 7.95215C1.03717 7.95215 0.859 7.88032 0.7155 7.73665C0.571833 7.59315 0.5 7.41498 0.5 7.20215V1.3559C0.5 1.09823 0.58625 0.883148 0.75875 0.710648C0.931084 0.538314 1.14617 0.452148 1.404 0.452148H7.25C7.46283 0.452148 7.641 0.523898 7.7845 0.667398C7.92817 0.811065 8 0.989315 8 1.20215C8 1.41498 7.92817 1.59315 7.7845 1.73665C7.641 1.88032 7.46283 1.95215 7.25 1.95215H3.05375L8.827 7.72515C8.88467 7.78282 8.95833 7.81165 9.048 7.81165C9.13783 7.81165 9.21158 7.78282 9.26925 7.72515L15.9288 1.06565C16.0776 0.916815 16.2517 0.843398 16.451 0.845398C16.6503 0.847231 16.8276 0.925731 16.9827 1.0809C17.1276 1.23606 17.2026 1.41173 17.2078 1.6079C17.2128 1.80406 17.1377 1.97965 16.9827 2.13465L10.3288 8.78865C10.1481 8.96932 9.94558 9.10323 9.72125 9.1904C9.49675 9.27773 9.27233 9.3214 9.048 9.3214C8.82367 9.3214 8.59933 9.27773 8.375 9.1904C8.15067 9.10323 7.94808 8.96932 7.76725 8.78865L2 3.02115Z",
    fill: "#F44649"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedCallIcon);
export default __webpack_public_path__ + "static/media/missedCallIcon.70ee6c565020034559194009a0c1d9bd.svg";
export { ForwardRef as ReactComponent };